import {
  LAYOUT_TYPES,
  LAYOUT_MODE_TYPES,
  LAYOUT_SIDEBAR_TYPES,
  LAYOUT_WIDTH_TYPES,
  LAYOUT_POSITION_TYPES,
  LAYOUT_TOPBAR_THEME_TYPES,
  LEFT_SIDEBAR_SIZE_TYPES,
  LEFT_SIDEBAR_VIEW_TYPES,
  LEFT_SIDEBAR_IMAGE_TYPES,
  PERLOADER_TYPES,
} from "../components/constants/layout";

/**
 * Changes the body attribute
 */
const changeHTMLAttribute = (attribute: string, value: string): boolean => {
  if (document.documentElement) {
    document.documentElement.setAttribute(attribute, value);
  }
  return true;
};

export const changeLayout = (layout: LAYOUT_TYPES) => {
  if (layout === LAYOUT_TYPES.TWOCOLUMN) {
    document.documentElement.removeAttribute("data-layout-width");
  } else if (layout === LAYOUT_TYPES.HORIZONTAL) {
    document.documentElement.removeAttribute("data-sidebar-size");
  } else if (layout === LAYOUT_TYPES.SEMIBOX) {
    changeHTMLAttribute("data-layout-width", "fluid");
    changeHTMLAttribute("data-layout-style", "default");
  }
  changeHTMLAttribute("data-layout", layout);
};

export const changeLayoutMode = (layoutMode: LAYOUT_MODE_TYPES) => {
  changeHTMLAttribute("data-bs-theme", layoutMode);
};

export const changeSidebarTheme = (theme: LAYOUT_SIDEBAR_TYPES) => {
  changeHTMLAttribute("data-sidebar", theme);
};

export const changeLayoutWidth = (layoutWidth: LAYOUT_WIDTH_TYPES) => {
  if (layoutWidth === "lg") {
    changeHTMLAttribute("data-layout-width", "fluid");
  } else {
    changeHTMLAttribute("data-layout-width", "boxed");
  }
};

export const changeLayoutPosition = (layoutposition: LAYOUT_POSITION_TYPES) => {
  changeHTMLAttribute("data-layout-position", layoutposition);
};

export const changeTopbarTheme = (topbarTheme: LAYOUT_TOPBAR_THEME_TYPES) => {
  changeHTMLAttribute("data-topbar", topbarTheme);
};

export const changeSidebarImageType = (leftsidebarImagetype: LEFT_SIDEBAR_IMAGE_TYPES) => {
  changeHTMLAttribute("data-sidebar-image", leftsidebarImagetype);
};

export const changePreLoader = (preloaderTypes: PERLOADER_TYPES) => {
  changeHTMLAttribute("data-preloader", preloaderTypes);
};

export const changeLeftsidebarSizeType = (leftsidebarSizetype: LEFT_SIDEBAR_SIZE_TYPES) => {
  switch (leftsidebarSizetype) {
    case "lg":
      changeHTMLAttribute("data-sidebar-size", "lg");
      break;
    case "md":
      changeHTMLAttribute("data-sidebar-size", "md");
      break;
    case "sm":
      changeHTMLAttribute("data-sidebar-size", "sm");
      break;
    case "sm-hover":
      changeHTMLAttribute("data-sidebar-size", "sm-hover");
      break;
    default:
      changeHTMLAttribute("data-sidebar-size", "lg");
  }
};

export const changeLeftsidebarViewType = (leftsidebarViewtype: LEFT_SIDEBAR_VIEW_TYPES) => {
  changeHTMLAttribute("data-layout-style", leftsidebarViewtype);
};

export const changeSidebarVisibility = (sidebarVisibilitytype: string) => {
  changeHTMLAttribute("data-sidebar-visibility", sidebarVisibilitytype);
};
